import { watchEffect } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useApi } from '@/functions/api'
import { useAuthStore } from '@/stores/auth'

export function useInitApp () {
  type AppInitResponse = {
    user: AuthUser,
    tenants: TenantInit[],
  }
  const route = useRoute()
  const router = useRouter()
  const auth = useAuthStore()
  const api = useApi()

  const initApp = async () => {
    // redirect to login page is handled by watch(app.authenticated) below
    const response = await api.GET<AppInitResponse>('app/init')
    auth.setAuthenticated(1)
    auth.setUser(response.user)

    auth.setTenants(response.tenants)
    auth.initTenantSelected()
  }

  watchEffect(() => {
    if (auth.authenticated === -1) {
      return
    }

    const guestRoutes = ['login', 'register', 'forget password', 'reset password']

    if (auth.authenticated === 1) {
      if (guestRoutes.includes(String(route.name))) {
        router.replace({ name: 'home' })
      }
      return
    }

    if (!guestRoutes.includes(String(route.name))) {
      router.replace({ name: 'login' })
    }
  })

  return {
    initApp,
  }
}
